import { Preview } from "../../../../../types/IAction";
import * as actions from "../../../../actions/invitados";
import { GetClubesAccesoInvitado } from "../../../../reducers/invitados";

export interface TabAccesosDispatcher {
  getClubesAccesoInvitado: (
    idInvitado: any
  ) => Promise<Preview<GetClubesAccesoInvitado>>;
}

export const tabBitacoraDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => TabAccesosDispatcher = dispatch => ({
  getClubesAccesoInvitado: (idInvitado: any) => {
    return dispatch(actions.getClubesAccesoInvitado(idInvitado));
  }
});
